import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import * as dndHelper from '../../../../helpers/dndHelper';

class OrderingMatchingOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            option: props.option,
            currentOption: props.currentOption,
            asset_id: props.asset_id,
            responseData: props.responseData,
            showCorrectResponseControls:props.showCorrectResponseControls,
            showUserResponses:props.showUserResponses,
            locale: appHelper.getLocalData(props.option),
            id: `${props.asset_id}_${props.option.option_id}`,
            ref: `ref_option_${props.option.option_id}`,
            labelRef: `ref_option_label-${props.option.option_id}`,
            labelWidth: props.labelWidth,
            isDragDisabled: props.isDragDisabled,
        };
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.removeOption = this.removeOption.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.onClickFunction = this.onClickFunction.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.setCurrentOption = this.setCurrentOption.bind(this);
        this.setCurrentOptionKeyboardAccessibility = this.setCurrentOptionKeyboardAccessibility.bind(this);
        this.getOptionLabel = this.getOptionLabel.bind(this);
        this.getOrderingOptionLabel = this.getOrderingOptionLabel.bind(this);
        this.getMatchingOptionLabel = this.getMatchingOptionLabel.bind(this);
        this.getOptionAnswerLabel = this.getOptionAnswerLabel.bind(this);
        this.getOrderingOptionAnswerLabel = this.getOrderingOptionAnswerLabel.bind(this);
        this.getMatchingOptionAnswerLabel = this.getMatchingOptionAnswerLabel.bind(this);
        this.setLabelWidth = this.setLabelWidth.bind(this);
    }

    componentDidMount() {
        this.onOptionRevealed();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.responseData !== nextProps.responseData){
            this.setState({responseData: Object.assign({},nextProps.responseData)});
        }

        if(this.state.option !== nextProps.option){
            this.setState({option: Object.assign({},nextProps.option)});
        }

        if(this.state.currentOption !== nextProps.currentOption){
            this.setState({currentOption: Object.assign({},nextProps.currentOption)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }

        if(this.state.showCorrectResponseControls !== nextProps.showCorrectResponseControls){
            this.setState({showCorrectResponseControls: nextProps.showCorrectResponseControls});
        }

        if(this.state.showUserResponses !== nextProps.showUserResponses){
            this.setState({showUserResponses: nextProps.showUserResponses});
        }

        if(this.state.labelWidth !== nextProps.labelWidth){
            this.setState({labelWidth: nextProps.labelWidth});
        }

        if(this.state.isDragDisabled !== nextProps.isDragDisabled){
            this.setState({isDragDisabled: nextProps.isDragDisabled});
        }

    }

    componentDidUpdate() {
    }

    onClickFunction(){
        if  (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.props.onShowReview();
        }
    }

    getOptionClass() {
        let className = this.state.option.answered ? "answered" : "";
        if(this.state.showCorrectResponseControls){
            if(this.state.showUserResponses){
                if(this.props.showOutcome  || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                    if (this.props.currentlyChecked && (this.state.option.is_correct || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE)) {
                        className += ` ${this.state.option.result}`;
                    } else if (this.props.currentlyChecked && !this.state.option.is_correct && this.props.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE) {
                        className += ` poor`;
                    }
                }else{
                    className += ` assessment`;
                }
            }else{
                if(this.props.showOutcome  || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                    className += ` ${this.state.option.result}`;
                }else{
                    className += ` assessment`;
                }
            }
        }else{
            if(this.props.currentlyChecked && (this.state.option.is_correct || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE)){
                if(this.props.showOutcome  || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                    className += ` ${this.state.option.result}`;
                }else{
                    className += ` assessment`;
                }
            }else if(this.props.currentlyChecked && !this.state.option.is_correct && this.props.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE){
                if(this.props.showOutcome  || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                    className += ` poor`;
                }else{
                    className += ` assessment`;
                }
            }
        }

        if(this.props.currentlyChecked){
            className += ` disabled`;
        }

        if(this.props.asset_type_code === componentConstants.MATCHING){
            className += ` matching`;
        }

        return className;
    }

    getScreenReaderOptionClass() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
        if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
            return appHelper.getOptionResultString(this.state.option.result,false);
        }
    }

    renderOption(){
        /*let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked && this.props.currentlyChecked) {
            let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
            if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }*/
        return true;
    }

    getDisabledState() {
        if(this.props.currentlyChecked){
            return `disabled`;
        }
        return null;
    }

    getCheckedState(){
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
        if(checkedIndex > -1){
            return `checked`;
        }
        return null;
    }



    onOptionRevealed(){
        let labelRef =  this.refs[this.state.labelRef];
        //console.log(`is longestOptions`,  this.props.longestOption.option_id === this.state.option.option_id, this.props.longestOption.option_id , this.state.option.option_id, labelRef.offsetWidth);
        let labelWidth = appHelper.isDefined(labelRef) && this.props.longestOption.option_id === this.state.option.option_id ? labelRef.offsetWidth : 0;
        //console.log(`labelWidth`,labelWidth);
        this.props.onOptionRevealed(this.props.option, labelWidth);
    }

    removeOption() {
        //this.setState({render: false});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if(this.getDisabledState() !== 'disabled') {
                this.onOptionClick();
            }
        }
    }

    onOptionClick(){
        if(this.getDisabledState() !== 'disabled') {
            this.props.onOptionClick(this.state.option.option_id, this.state.option.selected_option);
        }
    }

    setCurrentOption(){
        if(this.getDisabledState() !== 'disabled') {
            this.props.setCurrentOption(this.state.option);
        }
    }


    setCurrentOptionKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if(this.getDisabledState() !== 'disabled') {
                this.setCurrentOption();
            }
        }
    }

    getOptionLabel() {
        if(this.props.asset_type_code === componentConstants.ORDERING){
            return this.getOrderingOptionLabel();
        }else if(this.props.asset_type_code === componentConstants.MATCHING){
            return this.getMatchingOptionLabel();
        }

    }
    getOrderingOptionLabel(){
        return this.state.option.display_order.toString();
    }

    getMatchingOptionLabel(){
        return appHelper.getLocalData(this.state.option).option;
    }

    getOptionAnswerLabel() {
        if(this.props.asset_type_code === componentConstants.ORDERING){
            return this.getOrderingOptionAnswerLabel();
        }else if(this.props.asset_type_code === componentConstants.MATCHING){
            return this.getMatchingOptionAnswerLabel();
        }

    }
    getOrderingOptionAnswerLabel(){
        let userResponse = appHelper.getLocalData(this.state.option.selected_option).option;
        let correctResponse = appHelper.getLocalData(this.state.option).option;
        if (this.state.showCorrectResponseControls) {
            return this.state.showUserResponses ? userResponse : correctResponse;
        } else {
            return userResponse;
        }
    }

    getMatchingOptionAnswerLabel(){
        let userResponse = appHelper.getLocalData(this.state.option.selected_option).option_match;
        let correctResponse = appHelper.getLocalData(this.state.option).option_match;
        if(this.state.showCorrectResponseControls){
            return this.state.showUserResponses ? userResponse : correctResponse;
        }else{
            return userResponse;
        }
    }

    setLabelWidth(){
        if(this.state.labelWidth > 0){
            return {
                width: `${this.state.labelWidth}px`,
            };
        }
    }


    render() {
        return (
            this.renderOption()
                ?
                <div className={`ordering-option  ${this.getOptionClass()}`} ref={this.state.ref}>
                    <div className={`option-label  ${this.state.option.option_id === this.state.currentOption.option_id ? "active" : ""}`} style={this.setLabelWidth()} onClick={this.setCurrentOption} tabIndex="0" role="button" onKeyDown={this.setCurrentOptionKeyboardAccessibility} dangerouslySetInnerHTML={{__html: this.getOptionLabel()}} ref={this.state.labelRef}/>

                    <Draggable key={`drag_option_${this.state.option.option_id}`} draggableId={this.state.option.option_id} index={this.props.index} isDragDisabled={this.state.isDragDisabled}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className="option-answer"
                                style={dndHelper.getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                )}
                             >
                                <div  onClick={this.onOptionClick} tabIndex="0" role="button" onKeyDown={this.setKeyboardAccessibility} dangerouslySetInnerHTML={{__html: this.getOptionAnswerLabel()}}/>
                                <div className="drag-handle"  {...provided.dragHandleProps}  />
                            </div>
                            )}
                    </Draggable>
                </div>
                :
                null
        );
    }
}

OrderingMatchingOption.propTypes = {
    asset_type_code: PropTypes.string.isRequired,
    option: PropTypes.object.isRequired,
    currentOption: PropTypes.object.isRequired,
    asset_id:PropTypes.number.isRequired,
    questionChecked: PropTypes.bool.isRequired,
    currentlyChecked: PropTypes.bool.isRequired,
    responseData: PropTypes.object.isRequired,
    scoring_type: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    onOptionClick: PropTypes.func,
    setCurrentOption: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onShowReview: PropTypes.func,
    onOptionRevealed: PropTypes.func,
    callbacks: PropTypes.object,
    showCorrectResponseControls:PropTypes.bool,
    showUserResponses:PropTypes.bool,
    labelWidth:PropTypes.number,
    longestOption: PropTypes.object,
    isDragDisabled: PropTypes.bool,
    showOutcome: PropTypes.bool,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

OrderingMatchingOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderingMatchingOption);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/orderingMatching/OrderingMatchingOption.js
 **/